import { EMPTY_MASTER_SHIFTANY_MODEL } from "presentation/model/Shift/ShiftMaintenanceModel"; 
import { useState } from "react"; 
import { createContainer } from "react-tracked"; 
const { 
    Provider: ShiftMaintenanceProvider, 
    useTracked: useShiftMaintenanceTracked 
} = createContainer(() => useState(EMPTY_MASTER_SHIFTANY_MODEL), {concurrentMode: true}); 
export { ShiftMaintenanceProvider, useShiftMaintenanceTracked }; 
